import React from 'react';
import { useTheme } from '@mui/material';
import { getColors } from '../../Themes/default_color';
const AiChat = ({ inverse = false }) => {
    const theme = useTheme();
    const colors = getColors();
    const fillColor = inverse ? theme.palette.getContrastText(colors.Primary) : colors.Primary;
    return (React.createElement("svg", { width: "24", height: "24", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" },
        React.createElement("path", { d: "M8.00731 7.4212L9.62983 11.8062L14.0146 13.4288L9.62983 15.0514L8.00731 19.4365L6.38479 15.0514L2 13.4288L6.38479 11.8062L8.00731 7.4212Z", fill: fillColor }),
        React.createElement("path", { d: "M14.633 2L15.4442 4.19251L17.6366 5.00382L15.4442 5.81512L14.633 8.00763L13.8217 5.81512L11.6293 5.00382L13.8217 4.19251L14.633 2Z", fill: fillColor }),
        React.createElement("path", { d: "M17.9951 13.9898L19.0768 16.9132L22 17.9949L19.0768 19.0766L17.9951 22L16.9134 19.0766L13.9902 17.9949L16.9134 16.9132L17.9951 13.9898Z", fill: fillColor })));
};
export default AiChat;
